export default {
  toasts: {
    failed_to_create_website: 'Website aanmaken mislukt',
  },
  steps: {
    information: 'Informatie',
    template: 'Sjabloon',
  },
  buttons: {
    next: 'Volgende',
    previous: 'Vorige',
    create_website: 'Website aanmaken',
    preview_about_us: 'Over ons (Voorbeeld)',
  },
  about_us_modal: {
    title: 'Over ons (Voorbeeld)',
  },
  error_messages: {
    missing_fields: 'Sommige verplichte velden ontbreken. Vul alle benodigde informatie in voordat u verdergaat.',
  },
};
